




































import Vue, { PropType } from 'vue';
import EssayCard from '@/components/cards/EssayCard.vue';
import Correction from '@/dex-shared/models/CorrectionModel';

export default Vue.extend({
  components: {
    EssayCard,
  },
  props: {
    correction: {
      type: Object as PropType<Correction>,
      required: true,
    },
  },
  computed: {
    essay() {
      return this.correction.essay();
    },
    subject() {
      return this.essay.subject();
    },
    examMode() {
      if (this.subject.examMode) {
        return this.subject.examMode();
      } else {
        return {};
      }
    },
    source() {
      if (this.subject.examQuestionIds.length > 0) {
        let exams = this.subject.exams();
        if (exams.length > 0) {
          let examGroups = exams[0].examGroups();
          if (examGroups.length > 0) {
            return examGroups[0].title;
          }
        }
      }
      if (this.examMode.name) {
        return this.examMode.name;
      }
      return 'Outros';
    },
  },
});
